(function() {
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow['env'] || browserWindow['reportingEnv'] || browserWindow['dashboardEnv'] || {};

  const root =
    (typeof self == 'object' && self.self === self && self) ||
    (typeof global == 'object' && global.global === global && global) ||
    this ||
    {};
  const canonicalUrls = {
    // TODO: Check if this beta url is still valid
    '.*.beta.omnitracs.com': {
      env: 'beta',
      sso: {
        issuer: 'https://fedsso.omnitracs.com',
        logoutUrl: 'https://fedsso.omnitracs.com/idp/startSLO.ping',
        clientId: 'Omnitracs_One'
      },
      clients: {
        ifta: { url: 'https://taxmanager.beta.omnitracs.com' },
        dashboard: { url: 'https://portal.beta.omnitracs.com/en' },
        dashboard_en: { url: 'https://portal.beta.omnitracs.com/en' },
        dashboard_fr: { url: 'https://portal.beta.omnitracs.com/fr' },
        dashboard_es: { url: 'https://portal.beta.omnitracs.com/es' },
        reporting: { url: 'https://reports.beta.omnitracs.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.beta.omnitracs.com' },
        platform: { url: 'https://one-api.beta.omnitracs.com' }
      }
    },
    '.*stage.apps.dc11-stage-01.cld.omnitracs.com': {
      env: 'stage',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl: 'https://fedsso.perf.omnitracs.com/idp/startSLO.ping',
        clientId: 'Omnitracs_One'
      },
      clients: {
        ifta: {
          url:
            'https://omnitracs-ui-ifta-cartel-stage.apps.dc11-stage-01.cld.omnitracs.com'
        },
        dashboard: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-stage.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_en: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-stage.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_fr: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-stage.apps.dc11-stage-01.cld.omnitracs.com/fr'
        },
        dashboard_es: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-stage.apps.dc11-stage-01.cld.omnitracs.com/es'
        },
        reporting: {
          url:
            'https://omnitracs-ui-reporting-reports-stage.apps.dc11-stage-01.cld.omnitracs.com'
        }
      },
      apis: {
        ifta: { url: 'https://one-api.stage.omnitracs.com' },
        platform: { url: 'https://one-api.stage.omnitracs.com' }
      }
    },
    '.*perf.apps.dc11-stage-01.cld.omnitracs.com': {
      env: 'perf',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl: 'https://fedsso.perf.omnitracs.com/idp/startSLO.ping',
        clientId: 'Omnitracs_One'
      },
      clients: {
        ifta: {
          url:
            'https://omnitracs-ui-ifta-cartel-perf.apps.dc11-stage-01.cld.omnitracs.com'
        },
        dashboard: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-perf.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_en: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-perf.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_fr: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-perf.apps.dc11-stage-01.cld.omnitracs.com/fr'
        },
        dashboard_es: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-perf.apps.dc11-stage-01.cld.omnitracs.com/es'
        },
        reporting: {
          url:
            'https://omnitracs-ui-reporting-reports-perf.apps.dc11-stage-01.cld.omnitracs.com'
        }
      },
      apis: {
        ifta: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy-perf.apps.dc11-stage-01.cld.omnitracs.com'
        },
        platform: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy-perf.apps.dc11-stage-01.cld.omnitracs.com'
        }
      }
    },
    // TODO: Check if this uat url is still valid
    '.*uat.apps.dc11-stage-01.cld.omnitracs.com': {
      env: 'uat',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl: 'https://fedsso.perf.omnitracs.com/idp/startSLO.ping',
        clientId: 'Omnitracs_One'
      },
      clients: {
        ifta: {
          url:
            'https://omnitracs-ui-ifta-cartel-uat.apps.dc11-stage-01.cld.omnitracs.com'
        },
        dashboard: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-uat.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_en: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-uat.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_fr: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-uat.apps.dc11-stage-01.cld.omnitracs.com/fr'
        },
        dashboard_es: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-uat.apps.dc11-stage-01.cld.omnitracs.com/es'
        },
        reporting: {
          url:
            'https://omnitracs-ui-reporting-reports-uat.apps.dc11-stage-01.cld.omnitracs.com'
        }
      },
      apis: {
        ifta: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy-uat.apps.dc11-stage-01.cld.omnitracs.com'
        },
        platform: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy-uat.apps.dc11-stage-01.cld.omnitracs.com'
        }
      }
    },
    '.*test.apps.dc11-stage-01.cld.omnitracs.com': {
      env: 'test',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl: 'https://fedsso.perf.omnitracs.com/idp/startSLO.ping',
        clientId: 'Omnitracs_One'
      },
      clients: {
        ifta: {
          url:
            'https://omnitracs-ui-ifta-cartel-test.apps.dc11-stage-01.cld.omnitracs.com'
        },
        dashboard: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-test.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_en: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-test.apps.dc11-stage-01.cld.omnitracs.com/en'
        },
        dashboard_fr: {
          url:
            'https://omnitracs-ui-dashboard-dashboard-test.apps.dc11-stage-01.cld.omnitracs.com/fr'
        },
        dashboard_es: {
          url:
            'https://omnitracs-ui-dashboard-platform-test.apps.dc11-stage-01.cld.omnitracs.com/es'
        },
        reporting: {
          url:
            'https://omnitracs-ui-reporting-reports-test.apps.dc11-stage-01.cld.omnitracs.com'
        }
      },
      apis: {
        ifta: { url: 'https://one-api.test.omnitracsone.com' },
        platform: { url: 'https://one-api.test.omnitracsone.com' }
      }
    },
    '.*dev.apps.dc12-dev-01.cld.omnitracs.com': {
      env: 'dev',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl: 'https://fedsso.perf.omnitracs.com/idp/startSLO.ping',
        clientId: 'Omnitracs_One'
      },
      clients: {
        ifta: {
          url:
            'https://omnitracs-ui-ifta-platform-dev.apps.dc12-dev-01.cld.omnitracs.com'
        },
        dashboard: {
          url:
            'https://omnitracs-ui-dashboard-platform-dev.apps.dc12-dev-01.cld.omnitracs.com/en'
        },
        dashboard_en: {
          url:
            'https://omnitracs-ui-dashboard-platform-dev.apps.dc12-dev-01.cld.omnitracs.com/en'
        },
        dashboard_fr: {
          url:
            'https://omnitracs-ui-dashboard-platform-dev.apps.dc12-dev-01.cld.omnitracs.com/fr'
        },
        dashboard_es: {
          url:
            'https://omnitracs-ui-dashboard-platform-dev.apps.dc12-dev-01.cld.omnitracs.com/es'
        },
        reporting: {
          url:
            'https://omnitracs-ui-reporting-platform-dev.apps.dc12-dev-01.cld.omnitracs.com'
        }
      },
      apis: {
        ifta: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy.apps.dc12-dev-01.cld.omnitracs.com'
        },
        platform: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy.apps.dc12-dev-01.cld.omnitracs.com'
        }
      }
    },
    '.*apps.dc12-sndbx-05.cld.omnitracs.com': {
      env: 'sndbx',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl: 'https://fedsso.perf.omnitracs.com/idp/startSLO.ping',
        clientId: 'Omnitracs_One'
      },
      clients: {
        ifta: {
          url:
            'https://omnitracs-ui-ifta-cartel.apps.dc12-sndbx-05.cld.omnitracs.com'
        },
        dashboard: {
          url:
            'https://omnitracs-ui-dashboard-dashboard.apps.dc12-sndbx-05.cld.omnitracs.com/en'
        },
        dashboard_en: {
          url:
            'https://omnitracs-ui-dashboard-dashboard.apps.dc12-sndbx-05.cld.omnitracs.com/en'
        },
        dashboard_fr: {
          url:
            'https://omnitracs-ui-dashboard-dashboard.apps.dc12-sndbx-05.cld.omnitracs.com/fr'
        },
        dashboard_es: {
          url:
            'https://omnitracs-ui-dashboard-dashboard.apps.dc12-sndbx-05.cld.omnitracs.com/es'
        },
        reporting: {
          url:
            'https://omnitracs-ui-reporting-report.apps.dc12-sndbx-05.cld.omnitracs.com'
        }
      },
      apis: {
        ifta: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy.apps.dc12-sndbx-05.cld.omnitracs.com'
        },
        platform: {
          url:
            'https://envoy-gateway-proxy-envoy-gateway-proxy.apps.dc12-sndbx-05.cld.omnitracs.com'
        }
      }
    }
  };

  const ot1Urls = {
    '[a-z-]*.omnitracsone.com': {
      env: 'prod',
      sso: {
        issuer: 'https://fedsso.omnitracs.com',
        logoutUrl: 'https://login.omnitracsone.com/assets/deeplink/?to=/logout',
        clientId: 'TAX',
        flow: 'OT1_PROD'
      },
      clients: {
        ifta: { url: 'https://taxmanager.omnitracsone.com' },
        dashboard: { url: 'https://portal.omnitracsone.com/en' },
        dashboard_en: { url: 'https://portal.omnitracsone.com/en' },
        dashboard_fr: { url: 'https://portal.omnitracsone.com/fr' },
        dashboard_es: { url: 'https://portal.omnitracsone.com/es' },
        reporting: { url: 'https://reports.omnitracsone.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.omnitracsone.com' },
        platform: { url: 'https://one-api.omnitracsone.com' }
      }
    },
    '.*.stage.omnitracsone.com': {
      env: 'stage',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl:
          'https://login.stage.omnitracsone.com/assets/deeplink/?to=/logout',
        clientId: 'TAX',
        flow: 'OT1_STAGE'
      },
      clients: {
        ifta: { url: 'https://taxmanager.stage.omnitracsone.com' },
        dashboard: { url: 'https://portal.stage.omnitracsone.com/en' },
        dashboard_en: { url: 'https://portal.stage.omnitracsone.com/en' },
        dashboard_fr: { url: 'https://portal.stage.omnitracsone.com/fr' },
        dashboard_es: { url: 'https://portal.stage.omnitracsone.com/es' },
        reporting: { url: 'https://reports.stage.omnitracsone.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.stage.omnitracsone.com' },
        platform: { url: 'https://one-api.stage.omnitracsone.com' }
      }
    },
    '.*.perf.omnitracsone.com': {
      env: 'perf',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl:
          'https://login.perf.omnitracsone.com/assets/deeplink/?to=/logout',
        clientId: 'TAX',
        flow: 'OT1_PERF'
      },
      clients: {
        ifta: { url: 'https://taxmanager.perf.omnitracsone.com' },
        dashboard: { url: 'https://portal.perf.omnitracsone.com/en' },
        dashboard_en: { url: 'https://portal.perf.omnitracsone.com/en' },
        dashboard_fr: { url: 'https://portal.perf.omnitracsone.com/fr' },
        dashboard_es: { url: 'https://portal.perf.omnitracsone.com/es' },
        reporting: { url: 'https://reports.perf.omnitracsone.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.perf.omnitracsone.com' },
        platform: { url: 'https://one-api.perf.omnitracsone.com' }
      }
    },
    '.*.test.omnitracsone.com': {
      env: 'test',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl:
          'https://login.test.omnitracsone.com/assets/deeplink/?to=/logout',
        clientId: 'TAX',
        flow: 'OT1_TEST'
      },
      clients: {
        ifta: { url: 'https://taxmanager.test.omnitracsone.com' },
        dashboard: { url: 'https://portal.test.omnitracsone.com/en' },
        dashboard_en: { url: 'https://portal.test.omnitracsone.com/en' },
        dashboard_fr: { url: 'https://portal.test.omnitracsone.com/fr' },
        dashboard_es: { url: 'https://portal.test.omnitracsone.com/es' },
        reporting: { url: 'https://reports.test.omnitracsone.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.test.omnitracsone.com' },
        platform: { url: 'https://one-api.test.omnitracsone.com' }
      }
    },
    '.*.dev.omnitracsone.com': {
      env: 'dev',
      sso: {
        issuer: 'https://fedsso.perf.omnitracs.com',
        logoutUrl:
          'https://login.dev.omnitracsone.com/assets/deeplink/?to=/logout',
        clientId: 'TAX',
        flow: 'OT1_DEV'
      },
      clients: {
        ifta: { url: 'https://taxmanager.dev.omnitracsone.com' },
        dashboard: { url: 'https://portal.dev.omnitracsone.com/en' },
        dashboard_en: { url: 'https://portal.dev.omnitracsone.com/en' },
        dashboard_fr: { url: 'https://portal.dev.omnitracsone.com/fr' },
        dashboard_es: { url: 'https://portal.dev.omnitracsone.com/es' },
        reporting: { url: 'https://reports.dev.omnitracsone.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.dev.omnitracsone.com' },
        platform: { url: 'https://one-api.dev.omnitracsone.com' }
      }
    }
  };

  const esUrls = {
    '[a-z-]*.omnitracs.com': {
      env: 'prod',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://taxmanager.omnitracs.com' },
        dashboard: { url: 'https://portal.omnitracs.com/en' },
        dashboard_en: { url: 'https://portal.omnitracs.com/en' },
        dashboard_fr: { url: 'https://portal.omnitracs.com/fr' },
        dashboard_es: { url: 'https://portal.omnitracs.com/es' },
        reporting: { url: 'https://reports.omnitracs.com' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in prod
        ifta: { url: 'https://one-api.omnitracsone.com' },
        platform: { url: 'https://one-api.omnitracsone.com' }
      }
    },
    '.*.stage.omnitracs.com': {
      env: 'stage',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://taxmanager.stage.omnitracs.com' },
        dashboard: { url: 'https://portal.stage.omnitracs.com/en' },
        dashboard_en: { url: 'https://portal.stage.omnitracs.com/en' },
        dashboard_fr: { url: 'https://portal.stage.omnitracs.com/fr' },
        dashboard_es: { url: 'https://portal.stage.omnitracs.com/es' },
        reporting: { url: 'https://reports.stage.omnitracs.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.stage.omnitracsone.com' },
        platform: { url: 'https://one-api.stage.omnitracsone.com' }
      }
    },
    '.*.perf.omnitracs.com': {
      env: 'perf',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://taxmanager.perf.omnitracs.com' },
        dashboard: { url: 'https://portal.perf.omnitracs.com/en' },
        dashboard_en: { url: 'https://portal.perf.omnitracs.com/en' },
        dashboard_fr: { url: 'https://portal.perf.omnitracs.com/fr' },
        dashboard_es: { url: 'https://portal.perf.omnitracs.com/es' },
        reporting: { url: 'https://reports.perf.omnitracs.com' }
      },
      apis: {
        ifta: { url: 'https://one-api.perf.omnitracsone.com' },
        platform: { url: 'https://one-api.perf.omnitracsone.com' }
      }
    },
    '.*.int.omnitracs.com': {
      env: 'test',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://taxmanager.int.omnitracs.com' },
        dashboard: { url: 'https://portal.int.omnitracs.com/en' },
        dashboard_en: { url: 'https://portal.int.omnitracs.com/en' },
        dashboard_fr: { url: 'https://portal.int.omnitracs.com/fr' },
        dashboard_es: { url: 'https://portal.int.omnitracs.com/es' },
        reporting: { url: 'https://reports.int.omnitracs.com' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in test
        ifta: { url: 'https://one-api.test.omnitracsone.com' },
        platform: { url: 'https://one-api.test.omnitracsone.com' }
      }
    },
    '.*.dev.omnitracs.com': {
      env: 'dev',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://taxmanager.dev.omnitracs.com' },
        dashboard: { url: 'https://portal.dev.omnitracs.com/en' },
        dashboard_en: { url: 'https://portal.dev.omnitracs.com/en' },
        dashboard_fr: { url: 'https://portal.dev.omnitracs.com/fr' },
        dashboard_es: { url: 'https://portal.dev.omnitracs.com/es' },
        reporting: { url: 'https://reports.dev.omnitracs.com' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in dev
        ifta: { url: 'https://one-api.dev.omnitracsone.com' },
        platform: { url: 'https://one-api.dev.omnitracsone.com' }
      }
    },
    '.*.tkg-flt-prod.usdc01.solera.farm': {
      env: 'prod',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://omnitracs-ui-ifta.tkg-flt-prod.usdc01.solera.farm' },
        dashboard: { url: 'https://omnitracs-ui-dashboard.tkg-flt-prod.usdc01.solera.farm/en' },
        dashboard_en: { url: 'https://omnitracs-ui-dashboard.tkg-flt-prod.usdc01.solera.farm/en' },
        dashboard_fr: { url: 'https://omnitracs-ui-dashboard.tkg-flt-prod.usdc01.solera.farm/fr' },
        dashboard_es: { url: 'https://omnitracs-ui-dashboard.tkg-flt-prod.usdc01.solera.farm/es' },
        reporting: { url: 'https://omnitracs-ui-reporting.tkg-flt-prod.usdc01.solera.farm' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in dev
        ifta: { url: 'https://one-api.omnitracsone.com' },
        platform: { url: 'https://one-api.omnitracsone.com' }
      }
    },
    '.*.tkg-flt-cae.usdc01.solera.farm': {
      env: 'stage',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://omnitracs-ui-ifta.tkg-flt-cae.usdc01.solera.farm' },
        dashboard: { url: 'https://omnitracs-ui-dashboard.tkg-flt-cae.usdc01.solera.farm/en' },
        dashboard_en: { url: 'https://omnitracs-ui-dashboard.tkg-flt-cae.usdc01.solera.farm/en' },
        dashboard_fr: { url: 'https://omnitracs-ui-dashboard.tkg-flt-cae.usdc01.solera.farm/fr' },
        dashboard_es: { url: 'https://omnitracs-ui-dashboard.tkg-flt-cae.usdc01.solera.farm/es' },
        reporting: { url: 'https://omnitracs-ui-reporting.tkg-flt-cae.usdc01.solera.farm' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in dev
        ifta: { url: 'https://one-api.stage.omnitracsone.com' },
        platform: { url: 'https://one-api.stage.omnitracsone.com' }
      }
    },
    '.*.tkg-flt-lte.usdc01.solera.farm': {
      env: 'perf',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://omnitracs-ui-ifta.tkg-flt-lte.usdc01.solera.farm' },
        dashboard: { url: 'https://omnitracs-ui-dashboard.tkg-flt-lte.usdc01.solera.farm/en' },
        dashboard_en: { url: 'https://omnitracs-ui-dashboard.tkg-flt-lte.usdc01.solera.farm/en' },
        dashboard_fr: { url: 'https://omnitracs-ui-dashboard.tkg-flt-lte.usdc01.solera.farm/fr' },
        dashboard_es: { url: 'https://omnitracs-ui-dashboard.tkg-flt-lte.usdc01.solera.farm/es' },
        reporting: { url: 'https://omnitracs-ui-reporting.tkg-flt-lte.usdc01.solera.farm' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in dev
        ifta: { url: 'https://one-api.perf.omnitracsone.com' },
        platform: { url: 'https://one-api.perf.omnitracsone.com' }
      }
    },
    '.*.tkg-flt-qae.usdc01.solera.farm': {
      env: 'test',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://omnitracs-ui-ifta.tkg-flt-qae.usdc01.solera.farm' },
        dashboard: { url: 'https://omnitracs-ui-dashboard.tkg-flt-qae.usdc01.solera.farm/en' },
        dashboard_en: { url: 'https://omnitracs-ui-dashboard.tkg-flt-qae.usdc01.solera.farm/en' },
        dashboard_fr: { url: 'https://omnitracs-ui-dashboard.tkg-flt-qae.usdc01.solera.farm/fr' },
        dashboard_es: { url: 'https://omnitracs-ui-dashboard.tkg-flt-qae.usdc01.solera.farm/es' },
        reporting: { url: 'https://omnitracs-ui-reporting.tkg-flt-qae.usdc01.solera.farm' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in dev
        ifta: { url: 'https://one-api.test.omnitracsone.com' },
        platform: { url: 'https://one-api.test.omnitracsone.com' }
      }
    },
    '.*.tkg-flt-dev.usdc01.solera.farm': {
      env: 'dev',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'https://omnitracs-ui-ifta.tkg-flt-dev.usdc01.solera.farm' },
        dashboard: { url: 'https://omnitracs-ui-dashboard.tkg-flt-dev.usdc01.solera.farm/en' },
        dashboard_en: { url: 'https://omnitracs-ui-dashboard.tkg-flt-dev.usdc01.solera.farm/en' },
        dashboard_fr: { url: 'https://omnitracs-ui-dashboard.tkg-flt-dev.usdc01.solera.farm/fr' },
        dashboard_es: { url: 'https://omnitracs-ui-dashboard.tkg-flt-dev.usdc01.solera.farm/es' },
        reporting: { url: 'https://omnitracs-ui-reporting.tkg-flt-dev.usdc01.solera.farm' }
      },
      apis: {
        // Envoy is not enabled for omnitracs.com in dev
        ifta: { url: 'https://one-api.dev.omnitracsone.com' },
        platform: { url: 'https://one-api.dev.omnitracsone.com' }
      }
    },
    '.*localhost.*': {
      env: 'local',
      sso: {
        issuer: browserWindowEnv.issuer,
        logoutUrl: browserWindowEnv.logoutUrl,
        clientId: browserWindowEnv.clientId,
        flow: browserWindowEnv.flow
      },
      clients: {
        ifta: { url: 'http://localhost:4200' },
        dashboard: { url: 'http://localhost:4201' },
        dashboard_en: { url: 'http://localhost:4201/en' },
        dashboard_fr: { url: 'http://localhost:4201/fr' },
        dashboard_es: { url: 'http://localhost:4201/es' },
        reporting: { url: 'http://localhost:4202' }
      },
      apis: {
        ifta: { url: 'https://one-api.dev.omnitracsone.com' },
        platform: { url: 'https://one-api.dev.omnitracsone.com' }
      }
    }
  };

  const configs = {
    ...canonicalUrls,
    ...ot1Urls,
    ...esUrls
  };

  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = configs;
    }
    exports.configs = configs;
  } else {
    root.configs = configs;
  }
})();
